import { StrictMode } from 'react'
import { render } from 'react-dom'
import './index.css'
import ErrorBoundary from './ErrorBoundary'
import App from './App'
import reportWebVitals from './reportWebVitals'

render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
